module.exports = __webpack_public_path__ + "9cb669c07d9640b14e25054e32a67c0c.pdf";